export function getQueryParams(): Record<string, string> {
  const searchParams = new URLSearchParams(window.location.search)
  const result: Record<string, string> = {}
  searchParams.forEach((value: string, key: string) => {
    result[key] = value
  })

  return result
}
